$(window).bind("resize load", function () {
    var wW = $(this).width();
    var limit = 1024;

    if (wW >= limit) {
        $(".pdp__image").mouseenter(function (e) {
            e.preventDefault();
            $(this).mousemove(function (e) {
                zoom(e);
                $(this).find('img').css('opacity', '0');
            });
        });

        $(".pdp__image").mouseleave(function (e) {
            $(this).find('img').css('opacity', '1');
            $(this).unbind('mousemove');
        });
    } else {
        $(".pdp__image").unbind('mousemove');
    }
}).trigger('resize');

function zoom(e) {
    var x, y, offsetX, offsetY;
    var zoomer = e.currentTarget;

    if (e.offsetX) {
        offsetX = e.offsetX;
    } else {
        offsetX = e.touches[0].pageX;
    }

    if (e.offsetY) {
        offsetY = e.offsetY;
    } else {
        offsetY = e.touches[0].pageY;
    }

    x = (offsetX / zoomer.offsetWidth) * 100;
    y = (offsetY / zoomer.offsetHeight) * 100;

    zoomer.style.backgroundPosition = x + '% ' + y + '%';
}